export const type = 'alert.recordMessage';
